<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 overflow-hidden bg-smoke-lighter flex">
		<div class="relative bg-grey-lightest w-full max-w-md m-auto flex-col flex rounded m-8 overflow-scroll shadow-modal">
			<div class="w-full bg-green-light py-1"></div>
			<div class="flex py-2 m-2 px-4">
				<div class="flex-1 text-left">
					<p class="text-lg font-extrabold">Lägg till text</p>
				</div>
				<div class="flex-1">
					<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
						<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
					</button>
				</div>
			</div>

			<div class="h-full mx-6 mb-6 pb-2 pt-3">
				
				<div class="flex justify-center flex-wrap">
					
					<div class="w-3/4 mb-4">
						<div class="w-full px-3">
						<p class="text-left font-semibold mb-2">Rubrik</p>
							<input class="input-text" v-model="header">
						</div>
					</div>
					<div class="w-3/4 mb-4">
						<div class="w-full px-3">
						<p class="text-left font-semibold mb-2">Förnamn</p>
							<input class="input-text" v-model="name">
						</div>
					</div>

					<div class="w-3/4 mb-4">
						<div class="w-full px-3">
						<p class="text-left font-semibold mb-2">Efternamn</p>
							<input class="input-text" v-model="surname">
						</div>
					</div>

					<div class="w-3/4 mb-4">
						<div class="w-full px-3">
						<p class="text-left font-semibold mb-2">Adress</p>
							<input class="input-text" v-model="address">
						</div>
					</div>

					<div class="w-3/4 mb-4">
						<div class="w-full px-3">
						<p class="text-left font-semibold mb-2">Postnummer</p>
							<input class="input-text" v-model="post_nbr">
						</div>
					</div>

					<div class="w-3/4 mb-4">
						<div class="w-full px-3">
						<p class="text-left font-semibold mb-2">Postadress</p>
							<input class="input-text" v-model="post_address">
						</div>
					</div>
				</div>
			</div>

			<div class="w-full bg-grey-lightish py-4">
				<div class="float-right mr-4">
					<button @click="addTexts()" class="items-center w-auto py-2 px-2 pr-2 text-sm text-center text-white block bg-green hover:bg-green-dark rounded shadow-light font-bold">
						Lägg till texter
					</button>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {

	data() {
		return {
			show: false,
			page_id: null,
			header: '',
			footer: '',
			name: '',
			surname: '',
			address: '',
			post_nbr: '',
			post_address: '',
		}
	},

	computed: {

		...mapGetters({
			paperTypes:		'layout/paperTypes',
			customer:		'customer/customer',
			year:			'customer/year',
		}),

		page() {
			return this.$store.getters['layout/getPageById'](this.page_id)
		}
	},

	watch: {
		page() {
			if(!this.paperType) {
				this.paperType = this.page.paperType.slug
			}
		},

		customer() {
			if(this.customer) {
				this.fillCustomerInfo()
			}
		},

		year() {
			if(this.year) {
				this.header = "Markkartering " + this.year
			}
		}
	},

	mounted() {
		bus.$on('open-add-text-modal', this.openModal)
		bus.$on('close-add-text-modal', this.dismissModal)

		if(this.customer) {
			this.fillCustomerInfo()
		}

		if(this.year) {
			this.header = "Markkartering " + this.year
		}
	},

    beforeDestroy() {
        bus.$off('open-add-text-modal')
        bus.$off('close-add-text-modal')
    },

	methods: {
		openModal(page_id = null) {
			this.page_id = page_id
			this.show = true
			document.getElementById("body").className = "overflow-y-hidden";
			bus.$emit('deselect')
		},
		
		dismissModal() {
			this.show = false
			document.getElementById("body").className = "";
		},

		fillCustomerInfo() {
			this.name = this.customer.name 
			this.surname = this.customer.last_name 
			this.address = this.customer.adress 
			this.post_nbr = this.customer.post_nbr 
			this.post_address = this.customer.post_adress 
		},

		addTexts() {
			let footer = ""
			if(this.name && this.surname) {
				footer += this.name + " " + this.surname + "\n"
			} 
			footer += this.address ? this.address + "\n" : ''

			if(this.post_nbr && this.post_address) {
				footer += this.post_nbr + " " + this.post_address
			}

			this.$store.dispatch("layout/SET_PAGE_HEADER", {
				id: this.page_id, 
				header: this.header
			})
			this.$store.dispatch("layout/SET_PAGE_FOOTER", {
				id: this.page_id, 
				footer: footer
			})

			this.dismissModal()
		}
	}
}
</script>